(function () {
  document.documentElement.classList.add('js');

  var header = document.querySelector('[data-header]');
  if (!header) return;

  var toggle = header.querySelector('[data-menu-toggle]');
  var mobileMenu = header.querySelector('[data-mobile-menu]');
  if (!toggle || !mobileMenu) return;

  toggle.addEventListener('click', function () {
    var isOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!isOpen));
    toggle.setAttribute('aria-label', isOpen ? 'Open menu' : 'Close menu');
    if (isOpen) {
      mobileMenu.setAttribute('hidden', '');
      header.classList.remove('menu-open');
    } else {
      mobileMenu.removeAttribute('hidden');
      header.classList.add('menu-open');
    }
  });
})();
